import { Box, Stack, Text, Title } from "@mantine/core";
import { ButtonCheckboxV1 } from "./ButtonCheckboxV1";
import type { ButtonsSelectProps } from "./ButtonSelect";
import { isDataGroupItemGroup } from "./ButtonSelect.utils";
import { getNextValue, handleGroupBlur } from "../utils/select";

export const ButtonSelectV1 = ({
  data,
  numberOfColumns = 2,
  align = "center",
  value,
  onChange,
  error,
  label,
  allowDeselect,
  onBlur,
}: ButtonsSelectProps) => {
  return (
    <Stack gap="xs" onBlur={handleGroupBlur(onBlur)}>
      {label && (
        <Text size="sm" variant="strong">
          {label}
        </Text>
      )}
      {isDataGroupItemGroup(data) ? (
        <Stack>
          <Box
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {data.map((groupData, groupIndex) => (
              <Box key={groupIndex}>
                {groupData.group && (
                  <Title
                    order={6}
                    style={{ marginBottom: "10px", fontWeight: 600 }}
                  >
                    {groupData.group}
                  </Title>
                )}
                <Box
                  style={theme => ({
                    display: "grid",
                    gridRowGap: theme.spacing.sm,
                    gridColumnGap: theme.spacing.sm,
                    gridTemplateColumns: Array.from({ length: numberOfColumns })
                      .map(() => "1fr")
                      .join(" "),
                    alignContent: "center",
                    justifyContent: "center",
                    marginBottom: theme.spacing.md,
                  })}
                >
                  {groupData.items?.map(item => {
                    const itemValue =
                      typeof item === "string" ? item : item.value;
                    const itemLabel =
                      typeof item === "string" ? item : item.label;
                    const itemDescription =
                      typeof item === "string" ? undefined : item.description;

                    return (
                      <ButtonCheckboxV1
                        id={itemValue}
                        key={itemValue}
                        description={itemDescription}
                        isActive={value === itemValue}
                        onClick={() =>
                          onChange(
                            getNextValue(itemValue, { value, allowDeselect })
                          )
                        }
                        align={align}
                        error={error}
                        style={{
                          height: "auto",
                          minHeight: "44px",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                        }}
                      >
                        {itemLabel}
                      </ButtonCheckboxV1>
                    );
                  })}
                </Box>
              </Box>
            ))}
          </Box>
          {error && (
            <Text size="xs" c="red">
              {error}
            </Text>
          )}
        </Stack>
      ) : (
        <Stack>
          <Box
            style={theme => ({
              display: "grid",
              gridAutoRows:
                numberOfColumns === 1 ? "minmax(80px, auto)" : undefined,
              gridRowGap: theme.spacing.sm,
              gridTemplateColumns: Array.from({ length: numberOfColumns })
                .map(() => "1fr")
                .join(" "),
              minHeight: "30%",
              minWidth: "30%",
              alignContent: "center",
              justifyContent: "center",
            })}
          >
            {data?.map(item => {
              const itemValue = typeof item === "string" ? item : item.value;
              const itemLabel = typeof item === "string" ? item : item.label;
              const itemDescription =
                typeof item === "string" ? undefined : item.description;

              return (
                <ButtonCheckboxV1
                  id={itemValue}
                  key={itemValue}
                  description={itemDescription}
                  onClick={() =>
                    onChange(getNextValue(itemValue, { value, allowDeselect }))
                  }
                  isActive={itemValue === value}
                  error={error}
                  align={align}
                  style={{
                    minHeight: "100%",
                  }}
                >
                  {itemLabel}
                </ButtonCheckboxV1>
              );
            })}
          </Box>
          {error && (
            <Text size="xs" c="red">
              {error}
            </Text>
          )}
        </Stack>
      )}
    </Stack>
  );
};
